var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 7.06344C1.875 4.23934 4.16439 1.94995 6.98848 1.94995C9.81258 1.94995 12.102 4.23934 12.102 7.06344C12.102 9.52138 10.3673 11.5753 8.05498 12.0656L7.78561 12.1228L7.68988 12.3809L6.98848 14.2727L6.28708 12.3809L6.19135 12.1228L5.92199 12.0656C3.60971 11.5753 1.875 9.52138 1.875 7.06344ZM6.98848 0.949951C3.6121 0.949951 0.875 3.68705 0.875 7.06344C0.875 9.90615 2.81476 12.2947 5.44254 12.9796L6.40247 15.5686C6.60403 16.1123 7.37294 16.1123 7.5745 15.5686L8.53443 12.9796C11.1622 12.2947 13.102 9.90615 13.102 7.06344C13.102 3.68705 10.3649 0.949951 6.98848 0.949951ZM5.41388 7.06345C5.41388 6.19385 6.11884 5.48889 6.98844 5.48889C7.85804 5.48889 8.563 6.19385 8.563 7.06345C8.563 7.93305 7.85804 8.63801 6.98844 8.63801C6.11884 8.63801 5.41388 7.93305 5.41388 7.06345ZM6.98844 4.48889C5.56655 4.48889 4.41388 5.64156 4.41388 7.06345C4.41388 8.48534 5.56655 9.63801 6.98844 9.63801C8.41033 9.63801 9.563 8.48534 9.563 7.06345C9.563 5.64156 8.41033 4.48889 6.98844 4.48889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.135b0ef6.svg";
export { ForwardRef as ReactComponent };